export default { sha: '28cedc5c9f6ed20a561d318232c4bf4e0a0f47ab', buildNumber: 'undefined' }
